export { renderSpinner_unstable as renderSpinner } from '@fluentui/react-spinner';
